// EffectGenerationSessionStatus represents a status of effect generation session.
export const EffectGenerationSessionStatus = {
  PaymentRequired: "payment_required",
  Paid: "paid",
  Free: "free",
  Completed: "completed",
  RefundRequested: "refund_requested",
  Refunded: "refunded",
};

Object.freeze(EffectGenerationSessionStatus);

import EffectGenerationAttempt from "./EffectGenerationAttempt.js";

// EffectGenerationSession represents a session of effect generation.
export default class EffectGenerationSession {
    constructor(data) {
        this.status = data.status;
        this.isExpired = data.is_expired;
        this.uuid = data.uuid;
        this.cryptoPaymentDetails = data.crypto_payment_details || null;
        this.isFree = data.is_free || false;
        this.attempts = data.attempts?.map((attemptData) => new EffectGenerationAttempt(attemptData)) ?? [];
    }
}
